<script setup lang="ts">
import { useI18n } from '@/shared/i18n'
import { Alert } from '@/shared/ui/alert'
import { Button } from '@/shared/ui/button'

withDefaults(defineProps<{ retrying?: boolean }>(), { retrying: false })
const emit = defineEmits<{ retry: [] }>()
const { t } = useI18n()
</script>

<template>
  <main class="boot-error grid min-h-dvh place-items-center bg-canvas p-lg">
    <section
      class="boot-error__card grid w-[min(100%,32rem)] gap-md rounded-xl border border-border bg-surface p-xl shadow-card"
    >
      <Alert tone="danger" :title="t('shell.boot.errorTitle')">
        {{ t('shell.boot.errorDescription') }}
      </Alert>
      <Button variant="primary" :loading="retrying" @click="emit('retry')">
        {{ t('shell.boot.retry') }}
      </Button>
    </section>
  </main>
</template>
